import UrlParse from 'url-parse';
import QueryString from 'qs';

/**
 * @param {String} original
 * @param {Object} params
 * @return {string}
 */
function addQueryParams(original, params) {
    const url = new UrlParse(original);

    const query = _.omit(
        QueryString.parse(_.trimStart(url.query, '?')),
        _.keys(params)
    );

    url.query = QueryString.stringify(_.assign({}, query, params));

    return url.toString();
}

/**
 * @param {String} original
 * @param {Array} params
 * @return {string}
 */
function removeQueryParams(original, params) {
    const url = new UrlParse(original);

    const query = _.omit(
        QueryString.parse(_.trimStart(url.query, '?')), params
    );

    url.query = QueryString.stringify(query);

    return url.toString();
}


export {
    addQueryParams,
    removeQueryParams
}
